import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { add } from 'date-fns';

import { FormattedMessage, useIntl } from 'react-intl';

import Button from '../Button';
import SummaryItem from './Item/SummaryItem';
import { Accordion } from '../ProductSelectionPage/directvgo/accordion';
import {
  addExpirationDate,
  calculatePriceToExpiresAt,
  formatPricesByCountry,
  formatProductsByType, formattedInvoiceCurrency,
  getSalePrice
} from '../../utils/products';
import { selectAccountProducts, selectActivePlanSubscription } from '../../queries/selectors/products';
import { selectTotalPriceSummary } from '../../queries/selectors/bootstrap';
import { selectTransactionByExternalId } from '../../queries/selectors/transactions';


const addExpiredAtToPurchasedProducts = (purchasedProducts) => {
  return purchasedProducts?.map(addExpirationDate);
}

const Summary = ({
  selectedProducts,
  handleContinueButton,
  subscriptions,
  isOnlyShowing,
  title,
  couponApply,
  products,
  mainSubscription,
  user,
  setPriceToShow,
  priceToShow,
  recurrenceToShow,
  recurrenceToShowInsummary,
  totalFormattedReduxPrice,
  isAddOnProduct,
  mainSubscriptionTransaction
}) => {
  const intl = useIntl();
  let plan;
  const [hasProrated, setHasProrated] = useState(false);
  let checkoutProducts = addExpiredAtToPurchasedProducts(selectedProducts);
  if (!mainSubscription) {
    plan = selectedProducts.find(product => product.productType === 'plan');
    if (plan) {
      const expiresAt = plan?.expiresAt ? plan?.expiresAt : add(new Date(), { [plan.interval.unit + 's']: plan?.interval?.amount });
      mainSubscription = { expiresAt };
    }
  }

  let mainSubscriptionProduct = null;
  if (checkoutProducts.map(product => product.productType).includes('plan')) {
    mainSubscriptionProduct = products?.find(product => product.productID === mainSubscription.productId);
  }

  checkoutProducts = calculatePriceToExpiresAt(mainSubscription, checkoutProducts, mainSubscriptionProduct, user, mainSubscriptionTransaction);

  const isPlanWithPurchasedUrns = (product, user) => {
    const newUrns = product.urns;
    return (product.productType === 'plan' && newUrns.every(urn => user.urn.includes(urn)))
  }

  const getSummaryTotal = (products, user, withoutDiscount = false) => {
    const totalProducts = products && products.length && products.reduce((acc, item) => {
      const productSubscription = subscriptions?.find(subscription => subscription.productID === item.productID);
      const isConsumedFreeTrial = !!(productSubscription && productSubscription.subscriptionState?.renewalNumber > 0);
      if (!item.trial?.unit || isConsumedFreeTrial) {
        acc += item.isIncludedInPlan ? 0 : (item.discountPriceToShow >= 0 && !isPlanWithPurchasedUrns(item, user) && !withoutDiscount && item.productType === 'plan') ? item.discountPriceToShow : item.priceToShow;
      }
      return acc;
    }, 0);
    return totalProducts;
  };

  const productsByType = formatProductsByType(checkoutProducts);
  const total = getSummaryTotal(checkoutProducts, user);
  const totalPriceWithouDiscount = getSummaryTotal(checkoutProducts, user, true);
  const isDisabledContinue = checkoutProducts?.length === 0 && total === 0;
  const totalFormatted = formatPricesByCountry(total, user.country);
  const currencyFormatted = formattedInvoiceCurrency(user.country);

  const calculatePriceToShowInLeged = (amountWithoutDiscount, amountWithDiscount, user, couponEntered) => {
    let amountToShow = amountWithoutDiscount;
    if (couponEntered?.foreverCycles || couponEntered?.cyclesDuration || couponEntered?.duration === 'forever') {
      amountToShow = amountWithDiscount;
    }

    return formatPricesByCountry(amountToShow, user.country);
  }
  useEffect(() => {
    if (totalFormatted || Object.entries(couponApply).length) {
      setPriceToShow(totalFormatted);
    }
  }, [totalFormatted]);

  return (
    <>
      {title && (
        <div className="summary-title">
          {title}
        </div>
      )}
      <div className={cx('summary-add-pkg-card', {
        'summary-sticked': !isOnlyShowing,
      })}
      >
        <Accordion isFixed>
          {Object.entries(productsByType)
            .map(([productKey, productList]) => {
              return (
                <Accordion.Item key={productKey}>
                  <Accordion.Header isShowDropDown={false}>
                    <p className="summaryHeader__title">
                      <FormattedMessage
                        id={`Summary.productType.title.${productKey}`}
                        defaultMessage={intl.formatMessage({
                          id: 'Summary.productType.title.addOn',
                        })}
                      />
                    </p>
                  </Accordion.Header>
                  {productList.length && productList.map((item, index) => {
                    const productSubscription = subscriptions?.find(subscription => subscription.productId === item.productID);
                    const isConsumedFreeTrial = !!(productSubscription && productSubscription.subscriptionState?.renewalNumber > 0);
                    const applyTrial = !isConsumedFreeTrial && item.trial?.unit;
                    const availableSalePriceOffer = !applyTrial && getSalePrice(item);
                    const haveADiscount = item.discountPriceToShow >= 0 && !applyTrial;
                    const isByCoupon = couponApply?.products?.some(couponProduct => couponProduct === item.productID);

                    return (
                      <Accordion.Body key={index}>
                        <SummaryItem
                          applyTrial={applyTrial}
                          haveADiscount={haveADiscount}
                          products={products}
                          availableSalePriceOffer={availableSalePriceOffer}
                          item={item}
                          isByCoupon={isByCoupon}
                          user={user}
                          couponInfo={couponApply}
                          setHasProrated={setHasProrated}
                          recurrenceToShow={recurrenceToShow}
                          recurrenceToShowInsummary={recurrenceToShowInsummary}
                        />
                      </Accordion.Body>
                    );
                  })}
                </Accordion.Item>
              )
            })}
        </Accordion>
        {!isDisabledContinue && <hr />}
        <div className="summaryHeader">
          <p className="summaryTitle">
            <FormattedMessage id="MembershipSelectionPage.summary" />
            {
              hasProrated && <FormattedMessage id="MembershipSelectionPage.summary.today" />
            }
          </p>
          <p className="summaryTitle  summaryTitle--price">{totalFormatted || totalFormattedReduxPrice}</p>
        </div>
        {
          !couponApply?.cycles && !isAddOnProduct &&
          <div className="text-start mb-2 text-white">
            <FormattedMessage id="MembershipSelectionPage.summary.plan.small.legend" values={{
              price: couponApply?.duration === 'forever' ? totalFormattedReduxPrice : formatPricesByCountry(totalPriceWithouDiscount, user.country)
            }} />
          </div>
        }
        {
          couponApply?.cycles && !isAddOnProduct &&
          <div className="text-start mb-2 text-white">
            <FormattedMessage id="MembershipSelectionPage.summary.plan.small.legend.cycles" values={{
              totalPriceShow: calculatePriceToShowInLeged(totalPriceWithouDiscount, total, user, couponApply)
            }} />
          </div>
        }
        <div className="text-start mb-2 text-white">{currencyFormatted}</div>
        {!isOnlyShowing && (
          <div className="summary__button">
            <Button
              disabled={isDisabledContinue}
              text={<FormattedMessage id="Cancellation.continue" />}
              onClick={handleContinueButton}
            />
          </div>
        )}
      </div>
    </>
  );
};

Summary.propTypes = {
  selectedProducts: PropTypes.array,
  handleContinueButton: PropTypes.func,
  subscriptions: PropTypes.array,
  isOnlyShowing: PropTypes.bool,
  title: PropTypes.string,
  couponApply: PropTypes.object,
  mainSubscription: PropTypes.object,
  products: PropTypes.array.isRequired,
  user: PropTypes.object,
  setPriceToShow: PropTypes.func,
  priceToShow: PropTypes.string,
  recurrenceToShow: PropTypes.string,
  totalFormattedReduxPrice: PropTypes.string,
  mainSubscriptionTransaction: PropTypes.object
};

const mapStateToProps = (state) => ({
  mainSubscription: selectActivePlanSubscription(state),
  products: selectAccountProducts(state),
  totalFormattedReduxPrice: selectTotalPriceSummary(state),
  mainSubscriptionTransaction: selectTransactionByExternalId(state)
});


export default compose(
  connect(mapStateToProps),
)(Summary);
